import { render, staticRenderFns } from "./recommendPostList.vue?vue&type=template&id=623cf855&scoped=true"
import script from "./recommendPostList.vue?vue&type=script&lang=js"
export * from "./recommendPostList.vue?vue&type=script&lang=js"
import style0 from "./recommendPostList.vue?vue&type=style&index=0&id=623cf855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623cf855",
  null
  
)

export default component.exports